import React, { FC, MouseEvent } from 'react'
/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import {
  InfoBlockCallNowTextContainer,
  InfoBlockCallNowTextHours,
  InfoBlockCallNowTextText, InfoBlockCallNowTitle,
  phoneNumberBtnStyles,
} from './InfoBlockCallNowText.elements'
import {PhoneNumber} from '@components/PhoneNumber'
import { Button } from '@components/Button'
import {getPhoneNumber} from '@lib/PhoneNumber'
import Analytics from '@lib/Analytics'
import Pixels from '@lib/Pixels'

type Props = {
  text: string
  hours: string
  phoneMapping: PhoneMapping
  justText?: string
}

export const InfoBlockCallNowText: FC<Props> = ({text, hours, phoneMapping, justText}) => {

  const onClickCall = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    const number = getPhoneNumber(phoneMapping);
    Pixels.callEvent()
    Analytics.log('Click To Call', {
      location: 'info-block', info: `tel:${ number }`
    });
    window.location.href = `tel:${ number }`;
  }

  return (
    <InfoBlockCallNowTextContainer>
      { !justText &&
        <Button
        variant="link"
        fixedFont={true}
        onClick={onClickCall}
        key={phoneMapping.toString()}
        css={phoneNumberBtnStyles}
        aria-label="Click to Call"
      >
        Call&nbsp;
        <PhoneNumber mapping={phoneMapping} format={'pretty'}/>
      </Button>
      }
      { justText && <InfoBlockCallNowTitle dangerouslySetInnerHTML={{ __html: text }}/> }
      <InfoBlockCallNowTextHours dangerouslySetInnerHTML={{ __html: hours }}/>
      { !justText && <InfoBlockCallNowTextText dangerouslySetInnerHTML={{ __html: text }}/> }
    </InfoBlockCallNowTextContainer>
  )
}
